import storage from 'app/services/storage';

import { DEFAULT_DOMAIN_NAME } from 'constants/domains';
import { LS_ACCOUNTS_COMPANY_ID, LS_DOMAIN_NAME } from 'constants/localStorage';

export const getDomainName = () => {
  return storage.getItem(LS_DOMAIN_NAME) || DEFAULT_DOMAIN_NAME;
};

export const getCompanyId = () => {
  return storage.getItem(LS_ACCOUNTS_COMPANY_ID) || null;
};
